import fetchWithOptions from '../../../shared/utils/fetch';
import { Annotation, ServerAnnotation } from '../types/annotation-tasks.type';
import { wavesToList, tagsToList } from '../../auth/clients/preferences.client';

export const getNextAnnotation = async (): Promise<Annotation | null> => {
  try {
    const response = await fetchWithOptions<ServerAnnotation>(
      `/api/annotation/next`,
    );
    return jsonToAnnotation(response);
  } catch {
    return null;
  }
};

export const markAsFinished = async (
  annotationId: string,
): Promise<boolean> => {
  try {
    const response = await fetchWithOptions(
      `/api/annotation/${annotationId}/finish`,
      { method: 'POST' },
    );
    return !!response;
  } catch {
    return false;
  }
};

export const getLatestAnnotationForEcg = async (
  ecgId: string,
): Promise<Annotation | null> => {
  try {
    const response = await fetchWithOptions<ServerAnnotation>(
      `/api/annotation/ecg/${ecgId}`,
    );
    return jsonToAnnotation(response);
  } catch {
    return null;
  }
};

const jsonToAnnotation = (response: ServerAnnotation): Annotation | null => {
  if (response == null) {
    return null;
  }
  const {
    id: annotationId,
    ecg_id: ecgId,
    annotation_task: {
      id: annotationTaskId,
      name,
      description,
      annotation_grid: annotationGrid,
      settings,
      status,
    },
  } = response;

  const annotationTask: Annotation = {
    id: annotationId,
    ecgId,
    annotationTask: {
      id: annotationTaskId,
      name,
      description,
      annotationGrid,
      completion: '',
      annotators: [],
      createdAt: '',
      status,
      settings: {
        wavesToDisplay:
          settings.platane_annotation_settings != null
            ? wavesToList(
                settings.platane_annotation_settings['waves_to_display'],
              )
            : new Set(),
        wavesToAnnotate:
          settings.platane_annotation_settings != null
            ? wavesToList(
                settings.platane_annotation_settings['waves_to_annotate'],
              )
            : new Set(),
        tagsToDisplay:
          settings.platane_annotation_settings != null
            ? tagsToList(
                settings.platane_annotation_settings['tags_to_display'],
              )
            : { P: [], QRS: [] },
        tagsToAnnotate:
          settings.platane_annotation_settings != null
            ? tagsToList(
                settings.platane_annotation_settings['tags_to_annotate'],
              )
            : { P: [], QRS: [] },
        ...(settings.platane_save_diagnostic != null && {
          allowSaveDiagnostic: settings.platane_save_diagnostic,
        }),
        ...(settings.platane_save_delineation != null && {
          allowSaveDelineation: settings.platane_save_delineation,
        }),
        ...(settings.platane_auto_import_delineation != null && {
          autoImportDelineation: settings.platane_auto_import_delineation,
        }),
        ...(settings.platane_show_algo_diagnostic != null && {
          showAlgoDiagnostic: settings.platane_show_algo_diagnostic,
        }),
        ...(settings.platane_show_algo_delineation != null && {
          showAlgoDelineation: settings.platane_show_algo_delineation,
        }),
        ...(settings.platane_show_coworker_diagnostic != null && {
          showCoworkerDiagnostic: settings.platane_show_coworker_diagnostic,
        }),
        ...(settings.platane_show_coworker_delineation != null && {
          showCoworkerDelineation: settings.platane_show_coworker_delineation,
        }),
        ...(settings.platane_show_laddergram != null && {
          showLaddergram: settings.platane_show_laddergram,
        }),
      },
    },
  };

  return annotationTask;
};
